jQuery(function ($) {
  var AstroScript = {
    gotoDiv: {
      goTo: function () {
        let targets = ["#our-story", "#our-purpose", "#statistics"];

        $(".header__menu-item").click(function () {
          let divId = $(this).attr("href").replace("/", "");

          if (targets.includes(divId)) {
            let pad = -20;
            if (divId == "#our-purpose") {
              pad = 200;
            }

            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $(divId).offset().top + pad,
              },
              1000
            );

            if ($(divId).length > 0) {
              return false;
            }
          }
        });
      },

      init: function () {
        this.goTo();
      },
    },

    events: {
      tabs: function () {
        $(".e-upcoming-btn").click(function () {
          $(this).removeClass("inactive");
          $(".e-past-btn").addClass("inactive");
          $(".event-upcoming").show();
          $(".event-past").hide();
          AstroScript.paginator();
        });

        $(".e-past-btn").click(function () {
          $(this).removeClass("inactive");
          $(".e-upcoming-btn").addClass("inactive");
          $(".event-past").show();
          $(".event-upcoming").hide();
          AstroScript.paginator();
        });
      },

      paginate: function () {
        if ($(".s2-events").length <= 0) {
          return;
        }

        let indx = 1;
        $(".event-upcoming .s-e-event-item").each(function () {
          if (indx <= 3) {
            $(this).css("display", "flex");
          }
          indx++;
        });

        $(".events-pagination .s2-cus-pagination a").click(function (e) {
          e.preventDefault();

          $(".events-pagination .s2-cus-pagination a").removeClass(
            "page-active"
          );

          $(".events-pagination .s2-cus-pagination").attr(
            "data-currentpage",
            $(this).attr("data-page")
          );

          $(this).addClass("page-active");

          let start = ($(this).attr("data-page") - 1) * 3;

          if ($(this).attr("data-page") <= 1) {
            start = 0;
          }

          console.log(start);

          $(this).parents(".event-upcoming").find(".s-e-event-item").hide();

          for (i = 0; i < 3; i++) {
            $(this)
              .parents(".event-upcoming")
              .find(".s-e-event-item")
              .eq(start)
              .css("display", "flex");
            start++;
          }

          AstroScript.paginator();

          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $(".s-e-head h2").offset().top - 20,
            },
            1000
          );

          return false;
        });
      },

      init: function () {
        this.tabs();
        this.paginate();
      },
    },

    paginator: function () {
      if ($(".s2-cus-pagination").length <= 0) {
        return;
      }

      let $paginator = $(".s2-cus-pagination");
      let maxAround = $paginator.attr("data-maxaround");
      let maxRange = $paginator.attr("data-maxrange");
      let currentPage = $paginator.attr("data-currentpage");

      // Count amount of pages
      let totalPages = $paginator.children("a").length;
      let endRange = totalPages - maxRange;
      // Check if we're in the starting section
      let inStartRange = currentPage <= maxRange;
      // Check if we're in the ending section
      let inEndRange = currentPage >= endRange;

      // We need this for the span(s)
      let lastDotIndex = -1;

      // Remove all dots
      $("span.p-dots").remove();
      // Loop the pages
      $paginator.children("a").each(function (page, element) {
        // Index starts at 0, pages at 1
        ++page;
        let $element = $(element);
        if (page === 1 || page === totalPages) {
          // Always show first and last
          $element.show();
        } else if (inStartRange && page <= maxRange) {
          // Show element if in start range
          $element.show();
        } else if (inEndRange && page >= endRange) {
          // Show the element if in ending range
          $element.show();
        } else if (
          page === currentPage - maxAround ||
          page === currentPage ||
          page === currentPage + maxAround
        ) {
          // Show element if in the wrap around
          $element.show();
        } else {
          // Doesn't validate, hide it.
          // Append dot if needed
          $element.hide();

          if (
            lastDotIndex === -1 ||
            (!inStartRange &&
              !inEndRange &&
              $("span.p-dots").length < 2 &&
              page > currentPage)
          ) {
            lastDotIndex = page;
            // Insert dots after this page, we only have one or 2, and we can only insert the second one
            // if we're not in the start or end range, and it's past the current page
            $element.after('<span class="p-dots"></span>');
          }
        }
      });
    },

    episodes: {
      paginate: function () {
        if ($(".s2-e-shows-list").length <= 0) {
          return;
        }

        let indx = 1;
        $(".s2-e-shows-list .s2-e-shows-item").each(function () {
          if (indx <= 12) {
            $(this).show();
          }
          indx++;
        });

        $(".spotify-pagination .s2-cus-pagination a").click(function (e) {
          e.preventDefault();

          $(".spotify-pagination .s2-cus-pagination a").removeClass(
            "page-active"
          );
          $(".spotify-pagination .s2-cus-pagination").attr(
            "data-currentpage",
            $(this).attr("data-page")
          );
          $(this).addClass("page-active");

          let start = $(this).attr("data-page") * 12;

          $(".s2-e-shows-list .s2-e-shows-item").hide();
          for (i = 0; i < 12; i++) {
            $(".s2-e-shows-list .s2-e-shows-item").eq(start).show();
            start++;
          }

          AstroScript.paginator();

          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $(".main-page-title").offset().top - 20,
            },
            1000
          );

          return false;
        });

        $(".spotify-pagination .s2-prev-next a").click(function (e) {
          e.preventDefault();

          let pageNumber = 1;
          if ($(this).hasClass("pn-prev")) {
            if (
              parseInt(
                $(".spotify-pagination .s2-cus-pagination").attr(
                  "data-currentpage"
                )
              ) <= 1
            ) {
              return;
            }
            pageNumber =
              parseInt(
                $(".spotify-pagination .s2-cus-pagination").attr(
                  "data-currentpage"
                )
              ) - 1;
          } else if ($(this).hasClass("pn-next")) {
            if (
              parseInt(
                $(".spotify-pagination .s2-cus-pagination").attr(
                  "data-currentpage"
                )
              ) >=
              parseInt(
                $(".spotify-pagination .s2-cus-pagination").attr(
                  "data-totalpage"
                )
              )
            ) {
              return;
            }
            pageNumber =
              parseInt(
                $(".spotify-pagination .s2-cus-pagination").attr(
                  "data-currentpage"
                )
              ) + 1;
          }

          $(".spotify-pagination .s2-cus-pagination a")
            .eq(pageNumber - 1)
            .trigger("click");
        });
      },

      init: function () {
        this.paginate();
      },
    },

    stats: {
      counter: function () {
        if ($(".s2-statistics .stat-value").length <= 0) {
          return;
        }

        $(".s2-statistics .stat-value").each(function () {
          AstroScript.stats.animateCount($(this));
        });
      },

      animateCount: function (thisObj) {
        let i = 1;
        let state = 0;
        let inc = 10;
        let val = parseFloat(thisObj.data("value"));

        if (val < 50) {
          inc = 2;
        } else if (val > 50) {
          inc = 49;
        }

        setInterval(function () {
          if (state == 0) {
            let = unit = "";

            if (thisObj.attr("data-value").includes("%")) {
              unit = "%";
            }

            if (i < val) {
              thisObj.html(i + unit);
            } else {
              thisObj.html(thisObj.data("value"));
              state = 1;
            }

            i += inc;
          }
        }, 100);
      },

      init: function () {
        this.counter();
      },
    },
  };

  $(document).ready(function () {
    AstroScript.gotoDiv.init();
    AstroScript.events.init();
    AstroScript.paginator();
    AstroScript.episodes.init();
    AstroScript.stats.init();
  });
});
